export default "__VITE_ASSET__HuZ9o_Lc__"